import Repository from '../../repositories/RepositoryFactory';
const prescriptionsRepository = Repository.get('prescriptions');

export default {
	namespaced: true,
	state: {
		prescriptions: [],
		searchedPrescriptions: [],
	},
	mutations: {
		GET_PRESCRIPTIONS_BY_PATIENT_ID (state, payload) {
			state.prescriptions = payload;
		},
		FDA_SEARCH (state, payload) {
			state.searchedPrescriptions = payload;
		},
	},
	actions: {
		async getPrescriptionsByPatientId ({ commit }, patientId) {
			const response = await prescriptionsRepository.getPrescriptionsByPatientId(patientId);
			commit('GET_PRESCRIPTIONS_BY_PATIENT_ID', response.data);
		},
		async fdaSearch ({ commit }, body) {
			const response = await prescriptionsRepository.fdaSearch(body);
			commit('FDA_SEARCH', response.data);
		},
		async clearSearchedPrescriptions ({ commit }) {
			commit('FDA_SEARCH', []);
		},
		async deletePrescription ({ commit }, prescriptionId) {
			return await prescriptionsRepository.deletePrescription(prescriptionId);
		},
		async addPrescription ({ commit }, body) {
			return await prescriptionsRepository.addPrescription(body);
		},
		async updatePrescription ({ commit }, request) {
			return await prescriptionsRepository.updatePrescription(request.prescriptionId, request.body);
		},
	},
};
